export default "__VITE_ASSET__C_AyD1eh__"